import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const AlbumsIcon = ({ color = '#B5BCBD', size = '40', ...props }) => (
  <svg
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 44 44"
    {...props}
  >
    <g fill={color} fillRule="evenodd">
      <path d="M33.789 4.275a1.835 1.835 0 0 1 2.123 1.486l2.861 16.25a1.837 1.837 0 0 1-1.49 2.122l-2.45.431v9.31l7.653-1.348a1.838 1.838 0 0 0 1.487-2.123L38.887 1.514A1.837 1.837 0 0 0 36.764.028L7.877 5.112a1.842 1.842 0 0 0-1.49 2.122l.342 1.932h4.068c.24-.54.705-.97 1.327-1.08L33.79 4.274z" />
      <path d="M1.834 44h29.334a1.839 1.839 0 0 0 1.834-1.834V24.89L33 12.834A1.839 1.839 0 0 0 31.166 11H1.834A1.839 1.839 0 0 0 0 12.834v29.334A1.84 1.84 0 0 0 1.834 44zm1.832-27.5c0-1.009.825-1.834 1.834-1.834h22c1.009 0 1.834.825 1.834 1.834V33a1.839 1.839 0 0 1-1.834 1.834h-22A1.839 1.839 0 0 1 3.666 33V16.5z" />
    </g>
  </svg>
);

AlbumsIcon.propTypes = propTypes;

export default AlbumsIcon;
